export const AI_ANALYSIS_META = {
  prime_mover: {
    key: 'prime_mover',
    label: 'Prime Mover',
    icon: '💎',
    iconLabel: 'Prime mover',
  },
  fast_mover: {
    key: 'fast_mover',
    label: 'Fast Mover',
    icon: '⚡',
    iconLabel: 'Fast mover',
  },
  steady_mover: {
    key: 'steady_mover',
    label: 'Steady Mover',
    icon: '🧩',
    iconLabel: 'Steady mover',
  },
  season_winner: {
    key: 'season_winner',
    label: 'Season Winner',
    icon: '🍂',
    iconLabel: 'Season winner',
  },
  hidden_profit: {
    key: 'hidden_profit',
    label: 'Hidden Profit',
    icon: '🔍',
    iconLabel: 'Hidden profit',
  },
  risk_zone: {
    key: 'risk_zone',
    label: 'Risk Zone',
    icon: '⚠️',
    iconLabel: 'Risk zone',
  },
  low_potential: {
    key: 'low_potential',
    label: 'Low Potential',
    icon: '💤',
    iconLabel: 'Low potential',
  },
}

export const AI_ANALYSIS_PRIORITY = [
  'prime_mover',
  'fast_mover',
  'steady_mover',
  'season_winner',
  'hidden_profit',
  'risk_zone',
  'low_potential',
]

export const resolveRegionAIAnalysis = (regionData) => {
  if (!regionData || typeof regionData !== 'object') {
    return null
  }

  for (const key of AI_ANALYSIS_PRIORITY) {
    if (regionData[key]) {
      return AI_ANALYSIS_META[key] || null
    }
  }

  return null
}

export const AI_ANALYSIS_TAGS = AI_ANALYSIS_PRIORITY.map((key) => ({
  ...(AI_ANALYSIS_META[key] || { key, label: key }),
}))
